<template>

  <el-container>
    <!-- VALIDACIÓN DE SESIÓN -->
    <div v-if="verificandoCredenciales === true || cerrandoSesion === true"></div>

    <!-- MAIN VIEW — solo se muestra si el usuario está autenticado -->
    <MainContainer v-else-if="autenticado" />
    
    <!-- MODAL DE SESIÓN EXPIRADA -->
    <SesionExpiradaModal 
      v-if="showModalSesionExpirada"
      :onCloseModal="onCloseSesionExpiradaModal" 
    />

  </el-container>

</template>

<script>
  import { mapState } from 'vuex'
  import { ElLoading } from 'element-plus'
  import MainContainer from './MainContainer'
  import SesionExpiradaModal from './sesionExpiradaModal'

  export default {
    name: 'AppMain',
    components: { MainContainer, SesionExpiradaModal },
    data(){ 
      return {
        showModalSesionExpirada: false
      }
    },
    computed: {
      ...mapState({
        verificandoCredenciales: state => state.sesion.verificandoCredenciales,
        cerrandoSesion: state => state.sesion.cerrandoSesion,
        sesionExpirada: state => state.sesion.sesionExpirada,
        resultadoAutenticacion: state => state.sesion.resultadoAutenticacion
      }),
      autenticado() {
        return this.resultadoAutenticacion != null && this.resultadoAutenticacion !== undefined
      }
    },
    methods: {
      onCloseSesionExpiradaModal() {
        // cierro el modal
        this.showModalSesionExpirada = false

        // cierro sesión
        this.$store.dispatch('sesion/cerrarSesion')
        .then(()=> this.$router.push({ name: 'Login' }))
      }
    },
    mounted()
    {
      // muestro el loader de verificación de credenciales
      const loading = ElLoading.service({
        lock: true,
        text: this.$t('GENERAL_checkingCredentials')
      })

      // verifico las credenciales y cierro el loader      
      this.$store.dispatch('sesion/verificarCredenciales')
      .then((resultadoAuth) => { 
        loading.close() 
        if(resultadoAuth === undefined)
        this.$router.push({name: 'Login'})
      })
    },
    watch: {
      sesionExpirada(newVal) {
        
        if(newVal === false)
          return
        
        // muestro el modal de sesión expirada
        this.showModalSesionExpirada = true

        // vuelvo el valor de sesión expirada a falso para que vuelva a mostrar el modal en caso de navegación
        this.$store.commit('sesion/setSesionExpirada', false)
      }
    }
  }
</script>